import { render } from "./quote2_ingles.vue?vue&type=template&id=473bb2fd&scoped=true"
import script from "./quote2_ingles.vue?vue&type=script&lang=js"
export * from "./quote2_ingles.vue?vue&type=script&lang=js"

import "./quote2_ingles.vue?vue&type=style&index=0&id=473bb2fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473bb2fd"]])

export default __exports__